import type {Mapper} from 'framework';
import type {MealDetail, MealDetailEntry} from '../../domain/meal-detail';
import type {EditedMealDto, MealDetailDto} from '../dto/meal-detail.dto';

type MealDetailLikeDto = MealDetailDto | EditedMealDto;
type MealDetailEntryDto = MealDetailLikeDto['entries'][number];

const toEntry = (entry: MealDetailEntryDto): MealDetailEntry => ({
  id: entry.id,
  displayName: entry.displayName,
  sourceFoodId: entry.sourceFoodId,
  source: entry.source,
  quantity: entry.quantity,
  unit: entry.unit,
  gramEquivalent: entry.gramEquivalent,
  nutritionPer100g: entry.nutritionPer100g,
  kcal: entry.kcal,
  proteinGrams: entry.proteinGrams,
  carbsGrams: entry.carbsGrams,
  fatGrams: entry.fatGrams,
  notes: entry.notes,
});

export class MealDetailDtoToMealDetailMapper implements Mapper<MealDetailLikeDto, MealDetail> {
  transform(input: MealDetailLikeDto): MealDetail {
    return {
      id: input.id,
      nutritionDate: input.nutritionDate,
      mealType: input.mealType,
      consumedAt: input.consumedAt,
      entries: input.entries.map(toEntry),
      totalKcal: input.totalKcal,
      totalProteinGrams: input.totalProteinGrams,
      totalCarbsGrams: input.totalCarbsGrams,
      totalFatGrams: input.totalFatGrams,
    };
  }
}
